// Full design system specs for this https://www.figma.com/file/DTJQNF9WjnePH12CM3mHRy/Design-System?type=design&node-id=994-6403&mode=design&t=I7kv7GzKfzPHImVH-0

import { ReactNode } from 'react';
import classNames from 'classnames';
import { AvailableColors, Badge } from '@/components/Badge';

interface WizardBoxProps {
	label: string;
	description: string;
	icon: ReactNode;
	onClick?: () => void;
	testId?: string;
	badgeText?: string;
	badgeColor?: AvailableColors;
}

const WizardBox = (props: WizardBoxProps) => {
	const {
		label,
		description,
		icon,
		testId = 'WizardBox',
		onClick,
		badgeText,
		badgeColor,
	} = props;

	return (
		<button
			onClick={onClick}
			data-testid={testId}
			className={classNames(
				'flex-1 rounded-xl border bg-white  text-left',
				'w-full  md:text-center',
				'hover:cursor-pointer hover:border-transparent hover:outline-none hover:outline hover:outline-black',
				'focus:border-transparent focus:outline-none focus:outline focus:outline-black',
			)}
		>
			<div className="flex flex-1 items-center justify-between py-4 pl-5 pr-6 md:flex-col-reverse md:px-6 md:py-5 lg:px-3">
				<div>
					{badgeText && badgeColor && (
						<div className="mb-1 block md:hidden">
							<Badge color={badgeColor}>{badgeText}</Badge>
						</div>
					)}
					<p className="text-sm text-slate-500">
						<span className="block pb-1 text-base font-bold text-black">
							{label}
						</span>
						{description}
					</p>
				</div>
				<div
					aria-hidden="true"
					className="self-center justify-self-center md:mb-4"
				>
					{icon}
				</div>
				{badgeText && badgeColor && (
					<div className="mb-5 hidden md:block">
						<Badge color={badgeColor}>{badgeText}</Badge>
					</div>
				)}
			</div>
		</button>
	);
};

export default WizardBox;
